<template>
  <div>
    <v-card tile outlined>
      <v-container>
        <h3>Datos del alumno</h3>

        <v-form v-disable-all="userCanEdit || userCanEditLlodio" v-model="formAlumnoValid"
          @submit.prevent="onSubmit($event)">
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="itemAlumno.codigo" label="Nº Alumno" readonly></v-text-field>
              </v-col>
            </v-row>

            <alumno-datos-form-fields :alumno="itemAlumno" :nombreRules="nombreRules"
              :dateRules="fechaNacimientoRules"></alumno-datos-form-fields>

            <small>*Indica campo requerido</small>
          </v-card-text>

          <v-card-actions v-if="userCanEdit || userCanEditLlodio">
            <v-btn type="submit" color="primary" :loading="loading" text>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>

        <v-divider class="mb-6"></v-divider>

        <h3>Idiomas</h3>

        <alumno-idiomas-form v-if="userCanEdit || userCanEditLlodio" :idiomas="idiomas" :niveles="niveles"
          :alumno="itemAlumno" :idiomasAlumno="itemAlumnoIdiomas" :loadingGuardar="loadingIdiomas"
          @submit="onSubmitIdiomas" @delete="borrarIdioma"></alumno-idiomas-form>

        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Idioma</th>
                <th class="text-left">Nivel</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itemAlumnoIdiomas" :key="item.idioma.nombre">
                <td>{{ item.idioma.nombre }}</td>
                <td>{{ item.nivel.descripcion }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-card>

    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import AlumnoDatosFormFields from '@/components/prematricula/AlumnoDatosFormFields'
import AlumnoIdiomasForm from '@/components/prematricula/AlumnoIdiomasForm'
import { update } from '@/api/prematriculas.api'
import Confirm from '@/components/Confirm'
import _ from 'lodash'
import DateUtils from '@/libraries/DateUtils'

export default {
  name: 'AlumnoForm',

  components: {
    AlumnoDatosFormFields,
    AlumnoIdiomasForm,
    Confirm,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    userCanEdit: {
      type: Boolean,
      required: true,
    },

    userCanEditLlodio: {
      type: Boolean,
      required: true,
    },

    prematriculaAlumnosIdiomas: {
      type: Array,
      required: true,
    },

    idiomas: {
      type: Array,
      required: true,
    },

    niveles: {
      type: Array,
      required: true,
    },
  },

  data: () => {
    return {
      itemAlumno: null,
      itemAlumnoIdiomas: [],
      otrosAlumnosIdiomas: [],
      formAlumnoValid: false,
      loading: false,
      nombreRules: [
        v => !!v || 'El campo es obligatorio',
      ],
      fechaNacimientoRules: [
        v => !!v || 'El campo es obligatorio'
      ],
      loadingIdiomas: false,
    }
  },

  created() {
    this.itemAlumno = Object.assign(this.item.alumno)

    this.inicializarIdiomasAlumnoYOtros()

    let dateUtils = new DateUtils(this.itemAlumno.fechaNacimiento)
    this.itemAlumno.fechaNacimiento = dateUtils.formatDateYYYYMMDD()
  },

  watch: {
    prematriculaAlumnosIdiomas() {
      this.inicializarIdiomasAlumnoYOtros()
    },
  },

  methods: {
    inicializarIdiomasAlumnoYOtros() {
      this.itemAlumnoIdiomas = []
      this.otrosAlumnosIdiomas = []

      this.prematriculaAlumnosIdiomas.forEach((prematriculaAlumnoIdioma) => {
        if (prematriculaAlumnoIdioma.alumno.id === this.itemAlumno.id) {
          this.itemAlumnoIdiomas.push(prematriculaAlumnoIdioma)
        } else {
          this.otrosAlumnosIdiomas.push(prematriculaAlumnoIdioma)
        }
      })
    },

    async onSubmit(event) {
      this.loading = true;

      // validacion y emit
      if (this.formAlumnoValid) {
        let updatedAlumnos = []
        this.prematriculaAlumnosIdiomas.map((prematriculaAlumno) => {
          updatedAlumnos.push({
            id: prematriculaAlumno.id || null,
            alumno: prematriculaAlumno.alumno,
            // si el idioma esta vacio enviamos un null
            idioma: !_.isEmpty(prematriculaAlumno.idioma) ? prematriculaAlumno.idioma : null,
            // si el nivel esta vacio enviamos un null
            nivel: !_.isEmpty(prematriculaAlumno.nivel) ? prematriculaAlumno.nivel : null
          })
        })

        let params = {
          alumnos: updatedAlumnos
        }

        // actualizar datos de prematricula
        await update(this.item, params).then(response => {
          this.$emit('submitAlumno', event, response, this.itemAlumno)
        }).catch(error => {
          console.error(error)
        })
      }

      this.loading = false;
    },

    /**
     * Envio del formulario de idiomas, tener en cuenta que la llamada a la
     * api tiene que enviar los del usuario actual + los de los otros alumnos de la prematricula
     * si es que los hubiese.
     */
    async onSubmitIdiomas(event) {
      this.loadingIdiomas = true

      // unir todos los alumnosIdiomas de la prematricula para la query
      let alumnos = this.unirIdiomasPrematricula(this.itemAlumnoIdiomas, this.otrosAlumnosIdiomas)

      // Pasar idiomas o niveles como objetos vacios a nulos. Evitar 500 en el api.
      alumnos.map((prematriculaAlumno) => {
        if (prematriculaAlumno.idioma != null && _.isEmpty(prematriculaAlumno.idioma)) {
          prematriculaAlumno.idioma = null
        }

        if (typeof prematriculaAlumno.nivel === 'undefined' || (prematriculaAlumno.nivel != null && _.isEmpty(prematriculaAlumno.nivel))) {
          prematriculaAlumno.nivel = null
        }
        return prematriculaAlumno
      })

      let params = {
        alumnos: alumnos
      }

      // actualizar alumnos (array de alumnos)
      await update(this.item, params).then(response => {
        this.$emit('submitAlumnoIdiomas', event, response)
      }).catch(error => {
        console.error(error)
      })

      this.loadingIdiomas = false
    },

    /**
     * Accion de borrar un idioma del array de idiomas del alumno
     */
    async borrarIdioma(event, index) {
      let title = 'Borrar idioma'
      let subtitle = '¿Estás seguro?'
      let message = 'El idioma se eliminará de forma permanente al guardar el formulario.'
      let message2 = null

      // Se trata del último alumno/idioma asociado a la prematricula, si se deja así, la prematricula no volverá a ser accesible desde la intranet,
      // la tarea programada encargada de limpiar las prematriculasla eliminará posteriormente.
      if (this.itemAlumnoIdiomas.length + this.otrosAlumnosIdiomas.length == 1) {
        title = 'Borrar el último idioma'
        subtitle = 'No hay más alumnos/idiomas asociados a la prematrícula'
        message = 'El idioma se eliminará de forma permanente al guardar el formulario y la prematrícula será anulada.'
        message2 = '¿Borrar de todas formas?'
      }

      // confirmacion
      if (await this.$refs.confirm.open(
        title,
        subtitle,
        message,
        message2,
        {
          color: 'primary',
          width: 300
        })
      ) {
        // Si acepta borramos el item del array de idiomas del alumno
        this.itemAlumnoIdiomas.splice(index, 1)
      }
    },

    unirIdiomasPrematricula(idiomasAlumno, idiomasPrematricula) {
      const allIdiomas = [...idiomasAlumno, ...idiomasPrematricula]
      return _.uniqWith(allIdiomas, _.isEqual);
    },
  },
}
</script>
